import React from 'react';
import {useIntl} from 'react-intl';
import {useHistory} from 'react-router-dom';
import Styled from 'styled-components';
import {Alert, Button, EMPHASIS} from '@forecast-it/design-system';
import {BASELINE_TEMPLATES_PATH} from '../../../forecast-app/admin-tab/templates-page/templatesPaths';

// The Alert lays its text and its buttons side by side. Without a break point, a template name with no spaces
// would push View in Templates and the dismiss button off screen; the inherited rule lets it break anywhere.
const Wrapper = Styled.div`
	overflow-wrap: anywhere;
`;

type Props = {name: string; onDismiss: () => void};

/** Confirms a Baseline was saved as a template. Lives in the page's state, so it goes when the admin leaves. */
export const SaveAsTemplateBanner = ({name, onDismiss}: Props): JSX.Element => {
	const {formatMessage} = useIntl();
	const history = useHistory();
	return (
		// The design system's Alert has no live region of its own, so the wrapper announces it.
		<Wrapper role="status" data-cy="baseline-saved-as-template-banner">
			<Alert
				type={Alert.TYPE.SUCCESS}
				text={formatMessage({id: 'baseline_templates.save.banner'}, {name})}
				onDismiss={onDismiss}
			>
				<Button
					emphasis={EMPHASIS.MEDIUM}
					onPress={() => history.push(BASELINE_TEMPLATES_PATH)}
					data-cy="baseline-saved-as-template-view"
				>
					{formatMessage({id: 'baseline_templates.save.view_in_templates'})}
				</Button>
			</Alert>
		</Wrapper>
	);
};
